import { useEffect } from 'react';
import { logError } from '@/lib/log';
import { useLocation, useParams } from 'react-router';
import { recordPageViewEvent } from '@shared/services/analyticsService';
import { useAuth } from '../context/AuthContext';

/**
 * Fires analytics page view events on route changes.
 * Exercise routes are logged as `exercise:${id}`.
 */
export const usePageView = () => {
  const { currentUser } = useAuth();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    if (!currentUser) return;

    // Determine effective view name from pathname
    let view = location.pathname.slice(1) || 'home';

    // For exercise routes, include the module ID
    if (view.startsWith('exercise') && params.id) {
      view = `exercise:${params.id}`;
    }

    recordPageViewEvent(currentUser.uid, { view }).catch(logError);
  }, [currentUser, location.pathname, params.id]);
};
